import React from 'react'
import PropTypes from 'prop-types'

import { Login } from '@aok/icon-functional'

const OfferSearchContact = ({ contact, prefix, showIcon, className, titleClassName, logoClassName }) => {
  return (
    <div className={`${className} flex`}>
      {showIcon && <Login className={`h-16 w-16 fill-current shrink-0 ${logoClassName}`} />}
      {prefix && <p className={`pr-4 ${titleClassName}`}>{prefix}</p>}
      <p>{contact}</p>
    </div>
  )
}

OfferSearchContact.propTypes = {
  contact: PropTypes.string,
  prefix: PropTypes.string,
  showIcon: PropTypes.bool,
  className: PropTypes.string,
  titleClassName: PropTypes.string,
  logoClassName: PropTypes.string,
}

OfferSearchContact.defaultProps = {
  className: '',
  titleClassName: '',
  logoClassName: '',
}

export default OfferSearchContact
